<template>
  <div>
    <v-card :class="totop" flat>
      <div class="float-left width-full">
        <div class="width-full">
          <div class="chart-title float-left">
            <v-icon>image</v-icon>Media
          </div>
          <div v-if="editable" class="settings-button">
            <v-btn icon class="my-0" @click="edit ? edit = false : edit = true">
              <v-icon size="18" color="#808F9C">edit</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="width-full float-left pa-4">
          <vue-picture-swipe :items="items" :edit="edit" @delete="deleteImage"></vue-picture-swipe>
        </div>
      </div>
    </v-card>
    <div :class="dimmer" @click="edit = false"></div>
  </div>
</template>

<script>
import axios from "axios";
import VuePictureSwipe from "vue-picture-swipe";
export default {
  name: "Gallery",
  components: { VuePictureSwipe },

  props: {
    items: Array,
    parentType: String,
    storeKey: String,
    editable: Boolean
  },

  data() {
    return {
      countdownDelete: null,
      totop: "totop-off2",
      dimmer: "dimmer-off",
      edit: false,
      images: [],
      loading: false
    };
  },

  watch: {
    edit: function(newVal) {
      if (newVal === true) {
        this.totop = "totop";
        this.dimmer = "dimmer";
        this.countdownDelete = setTimeout(() => {
          this.edit = false;
        }, 8000);
      } else {
        this.dimmer = "dimmer-off";
        this.totop = "totop-off2";
        clearTimeout(this.countdownDelete);
      }
    }
  },

  methods: {
    deleteImage(imageId) {
      /*
      var apiData = {
        action: "UPDATE",
        component: this.storeKey,
        document: "Images",
        documentId: imageId,
        parentDocument: this.parentType,
        parentId: this.$route.params.id,
        key: "active",
        newValue: false,
        type: "deleteImage"
      };
      */

      axios
        .post("https://tradeinpool.com:3001/api/update/images/", {
          document: "Images",
          documentId: imageId,
          parentDocument: this.parentType,
          parentId: this.$route.params.id,
          key: "active",
          newValue: false,
          type: "deleteImage"
        })
        .then(response => {
          this.loading = false;
          this.edit = false;
          this.$emit("update", response.data);
        })
        .catch(err => {
          alert(err);
          this.loading = false;
        });

      clearTimeout(this.countdownDelete);
      this.countdownDelete = setTimeout(() => {
        this.edit = false;
      }, 8000);
    }
  }
};
</script>

<style>
</style>